<template>
  <div class="edit-content">
    <custom-dialog width="1400px" :title="model.title" :visible="visible"  v-on="$listeners" >
      <div class="app-content lease-content">
        <contract-lease-item :dialog="true"  :oldGoodsId="model.goodsId" :oldCategoryId="model.categoryId" :customerId="model.bigCustomerId" :orgId="model.orgId"  @success="onSyncList">
        </contract-lease-item>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
// import apis from '@/utils/apis';
import contractLeaseItem from '../contractLeaseItem/contract_lease_item.vue';


export default {
  components: {
    contractLeaseItem,
  },
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
  },
  watch: {
    // partnerId(val) {
    //   this.factoryId = val || '';
    //   // this.getCompanyDetail();
    // },
  },
  data() {
    return {
      tableCode: 'contract_scheme_supplies',
      visible: false,

      // 售后公司列表
      allServiceList: [],
      leaseId: ''
    };
  },
  mounted() {
    this.initDialog();

  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      // this.formSearch.schemeType = this.data.schemeType;
      // this.formSearch.currencyUnit = this.data.currencyUnit;
    },
    onSyncList: function (list) {
      this.$emit('success', list);
      this.closeDialog();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  }
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.edit-content{
  position: relative;
  .lease-content{
    height: 100% !important;
  }
}

</style>
